/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Directive, HostListener } from '@angular/core';

//TODO rename to iriroPreventKeyPress
@Directive({
  selector: '[irianPreventKeyPress], [iriroPreventKeyPress]',
})
export class PreventKeyPressDirective {
  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    event.preventDefault();
  }
}
